import React from 'react';
import {TrailFormData} from "types/Trail";
import {TextField} from "components/Form/Form/Field";
import {ClipboardCheckIcon, PlusIcon, TrashIcon} from "@heroicons/react/solid";
import Button from "components/Button";
import {FieldArray, FieldArrayConfig, FieldArrayRenderProps, FormikProps} from "formik";

export type RequirementListFieldProps = FieldArrayConfig & {
  required?: boolean
}

function RequirementListField({required, ...props}: RequirementListFieldProps) {
  return (
    <FieldArray {...props}>
      {({push, remove, form}: FieldArrayRenderProps) => {

        const requirements = (form as FormikProps<TrailFormData>).values.requirements

        return (
          <>
            <ul className='flex flex-col gap-3'>
              {requirements?.map((requirement, index) => (
                <li key={index} className="mb-2 flex space-x-4">
                  <div className="w-full">
                    <TextField
                      name={`${props.name}.${index}`}
                      label={`Requirement ${index + 1} *`}
                      hint='250 chars max'
                      icon={ClipboardCheckIcon}
                      maxLength={250}
                      autoComplete="off"
                      required={required}
                    />
                  </div>

                  <div className='translate-y-8'>
                    <Button
                      size={Button.sizes.X_SMALL}
                      color={Button.colors.WHITE}
                      icon={TrashIcon}
                      onClick={() => remove(index)}
                    />
                  </div>
                </li>
              ))}
            </ul>

            <div className={requirements?.length ? 'mt-4' : ''}>
              <Button
                color={Button.colors.SECONDARY}
                icon={PlusIcon}
                size={Button.sizes.TINY}
                onClick={() => push('')}
              >
                Add Requirement
              </Button>
            </div>
          </>
        )
      }}
    </FieldArray>
  );
}

export default RequirementListField;